import { UserAccount } from '@vue-storefront/core/modules/user/components/UserAccount'
import { AccountButton } from '@vue-storefront/core/modules/user/components/AccountButton'

// Component deprecated, now in User module

export default {
  name: 'MyProfile',
  mixins: [UserAccount, AccountButton]
}
